import SvgIcon from './SvgIcon';

export default function SearchIcon(props) {
  return (
    <SvgIcon {...props} width="16px" height="16px" viewBox="0 0 16 16">
      <path
        fill="#596168"
        fillRule="evenodd"
        d="M7.5,1 C11.0898509,1 14,3.91014913 14,7.5 C14,8.92122419 13.5438711,10.2359138 12.7700178,11.3056641 L16.5045588,14.5909839 C17.0746457,15.0774922 17.1423995,15.9340279 16.6558918,16.5041148 C16.1693834,17.0742018 15.3128477,17.1419555 14.7427608,16.6554479 C14.688411,16.6090662 14.6378094,16.5584646 14.5914278,16.5041148 L11.3046571,12.7707462 C10.2350887,13.5441573 8.92077825,14 7.5,14 C3.91014913,14 1,11.0898509 1,7.5 C1,3.91014913 3.91014913,1 7.5,1 Z M7.5,2.75 C4.87664744,2.75 2.75,4.87664744 2.75,7.5 C2.75,10.1233526 4.87664744,12.25 7.5,12.25 C10.1233526,12.25 12.25,10.1233526 12.25,7.5 C12.25,4.87664744 10.1233526,2.75 7.5,2.75 Z"
        transform="translate(-1 -1)"
      />
    </SvgIcon>
  );
}
